/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'cloud';

export const dnsResolverModalBreadcrumbTitle = `${prefix}.dnsResolverModalBreadcrumbTitle`;
export const cloudModalBreadcrumbTitle = `${prefix}.cloudModalBreadcrumbTitle`;
export const linuxHostServerBreadcrumbTitle = `${prefix}.linuxHostServerBreadcrumbTitle`;

export const ENGLISH = {
    [dnsResolverModalBreadcrumbTitle]: 'DNS Resolver',
    [cloudModalBreadcrumbTitle]: 'Cloud',
    [linuxHostServerBreadcrumbTitle]: 'Server',
};
